import { IPayPeriod } from "@/Common/api/types/CommissionCycle";

const resolvePart = (payPeriod?: IPayPeriod) => {
	if (payPeriod?.nextCCId) {
		return 1;
	}
	if (payPeriod?.previousCCId) {
		return 2;
	}
	return 0;
};

const resolveCCId = (pp1?: IPayPeriod | null, pp2?: IPayPeriod | null) => {
	if (pp1?.nextCCId) {
		return pp2?.previousCCId;
	}
	if (pp1?.previousCCId) {
		return pp2?.nextCCId;
	}
	return "";
};

export const combinePayPeriodsPositionStatus = (payPeriod?: IPayPeriod, partnerPayPeriod?: IPayPeriod | null, commissionCycleId = "") => {
	return [
		...(payPeriod?.positionStatus.map((item) => ({
			...item,
			commissionCycleId: resolveCCId(payPeriod, partnerPayPeriod) || commissionCycleId,
			part: resolvePart(payPeriod),
		})) ?? []),
		...(partnerPayPeriod?.positionStatus.map((item) => ({
			...item,
			commissionCycleId: resolveCCId(partnerPayPeriod, payPeriod),
			part: resolvePart(partnerPayPeriod),
		})) ?? []),
	];
};
